export default "__VITE_ASSET__BSkBVR6m__"